<h3 class="ui primary header">
  {{ modal.context.title }}
  <!-- <i class="link times icon" (click)="modal.deny(undefined)"></i> -->
</h3>
<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [close]="false"
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: pending }"
    style="padding: 0"
  >
    <div
      *ngIf="isActive && !recoveryActive"
      class="ui form"
      [formGroup]="twoFactorForm"
    >
      <p>
        Use the Authenticator App on your mobile device to obtain the code
        required for entry below.
      </p>
      <div class="field" [ngClass]="displayFieldCss('twoFactor_name')">
        <label>Enter OTP code from the application</label>
        <input type="text" formControlName="twoFactor_name" />
        <app-field-error-display
          [displayError]="isFieldValid('twoFactor_name')"
          errorMsg="Please enter twoFactor name"
        >
        </app-field-error-display>
      </div>
    </div>
    <div *ngIf="recoveryActive && !isActive">
      <p>
        If you lose access to your phone, you can authenticate to E-services
        using your recovery code. We recommend saving them with a secure
        password manager
      </p>
      <h4 style="color: #3f4395; font-family: 600; font-size: 14px">
        Recovery Codes Used:
        <span style="color: #505050; font-family: 400; font-size: 14px">
          {{ getUsedCodesCount() }} of {{ recoveryCodes.length }}</span
        >
      </h4>
      <div
        style="
          margin: 20px 0px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        "
      >
        <p
          *ngFor="let code of recoveryCodes"
          [style.color]="isCodeUsed(code) ? '#5050504D' : '#505050'"
          [style.fontWeight]="isCodeUsed(code) ? 'normal' : 'bold'"
        >
          {{ code.code }}
        </p>
      </div>
      <button
        class="ui primary button"
        [ngClass]="{ yellow: pending }"
        (click)="downloadToFileCode(recoveryCodes)"
        autofocus
      >
        Download
      </button>
      <div style="margin-top: 30px">
        <h4>Need new recovery codes?</h4>
        <p>
          If you think your codes have fallen into the wrong hands, you can get
          a new set. Be sure to save the new ones because the old ones will stop
          work
        </p>
        <p
          style="
            color: #3f4395;
            font-family: 600;
            font-size: 14px;
            text-decoration: underline;
            cursor: pointer;
          "
          (click)="generateNewCodeFunc()"
        >
          Generate new recovery codes
        </p>
      </div>
    </div>
    <div
      *ngIf="generateNewCode && !recoveryActive && !isActive"
      class="ui form"
      [formGroup]="twoFactorForm"
    >
      <p>
        Scan the image below with the two-factor Authenticator App on your
        phone.
      </p>
      <div class="ui vertical basic segment" appMargin marginY="0px">
        <iframe
          allowfullscreen
          [src]="barCode"
          style="border: none; height: 350px; width: 400px"
        ></iframe>
      </div>
      <p>
        After scanning the QR code image, the app will display a code that you
        can enter below.
      </p>
      <div class="field" [ngClass]="displayFieldCss('twoFactor_name')">
        <label>Enter the code from the application</label>
        <input type="text" formControlName="twoFactor_name" />
        <app-field-error-display
          [displayError]="isFieldValid('twoFactor_name')"
          errorMsg="Please enter twoFactor name"
        >
        </app-field-error-display>
      </div>
    </div>
    <div *ngIf="seeNewCode && !generateNewCode && !recoveryActive && !isActive">
      <h4 style="font-family: Roboto; font-size: 14px; font-weight: 500">
        Save your recovery code
      </h4>
      <div
        style="
          margin: 20px 0px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        "
      >
        <p *ngFor="let code of recoveryCodes" style="font-weight: bold">
          {{ code }}
        </p>
      </div>
      <button
        class="ui primary button"
        [ngClass]="{ yellow: pending }"
        (click)="downloadToFile(recoveryCodes)"
        autofocus
      >
        Download
      </button>
      <div style="margin-top: 30px">
        <h4 style="font-family: Roboto; font-size: 14px; font-weight: 500">
          Enter the code from the application
        </h4>
        <p style="font-family: Roboto; font-size: 14px; font-weight: 400">
          If you lose access to your phone, you can authenticate to E-services
          using your recovery code. We recommend saving them with a secure
          password manager
        </p>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button
    *ngIf="!recoveryActive || (recoveryActive && !isActive)"
    class="ui basic primary button"
    [disabled]="enabled"
    (click)="modal.deny(undefined)"
  >
    Cancel
  </button>
  <button
    *ngIf="!recoveryActive && !generateNewCode && !seeNewCode"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || enabled"
    (click)="submit()"
    autofocus
  >
    Continue
  </button>
  <button
    *ngIf="generateNewCode && !recoveryActive && !isActive && !seeNewCode"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || enabled"
    (click)="submitCodes()"
    autofocus
  >
    Continue
  </button>
  <button
    *ngIf="seeNewCode && !generateNewCode && !recoveryActive && !isActive"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    (click)="modal.approve()"
    autofocus
  >
    I have saved my recovery code
  </button>
</div>
